<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('langNew2.flzq')}}</div>
        </div>
        <div class="cotainer benefits">
            <ul class="ul">
              <li class="li" @click="jump(item)" v-for="(item,index) in flData" :key="index">
                <div class="banner-box"><img class="banner" :src="item.url" alt=""></div>
                <div class="title">{{item.title}}</div>
                <div class="status">{{$t('langNew2.jxz')}}</div>
              </li>
            </ul>
            <!-- 返回顶部 -->
            <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
            <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
            <!-- 暂无数据 -->
            <div class="null-box" v-show="isNoData">
              <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
              <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
              <p class="text">{{$t('zwsj.title')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'benefits',
    data () {
        return {
          theme: false,
          flData: [],
          isNoData: false,
          isGoTOP: false,
          curDataLength: 10,
          page: 1
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      this.getFuli()
    },
    methods: {
      back(){
          this.$router.go(-1)
      },
      jump(item){
        var id = item.id;
        if(this.filterHtmlTag(item.content)){
          this.$router.push({path: "/benefitsDetail",query: { id }});
        }
      },
      getFuli(){
		  	let params = {
          token:1,
          page: this.page
        }
        this.$ajax.get('/web/getFuli',{params}).then((res) => {
          let resData = res.data.data;
          if(resData.length > 0){
            this.flData = this.flData.concat(resData);
            this.curDataLength = resData.length;
          }else{
            this.curDataLength = resData.length;
          }
          if(this.flData.length > 0){
            this.isNoData = false;
          }else{
            this.isNoData = true;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      },
      filterHtmlTag(msg){
        var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
          msg = msg.replace(/[|]*\n/, '') //去除行尾空格
          msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
          return msg;
      },
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        left: .28rem;
        right: .28rem;
        top: 1.6rem;
        bottom: 0;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .li{
      margin: .5rem 0 .2rem 0;
      padding-bottom: .5rem;
      background: #fff;
      border-radius: .2rem;
    }
    .cotainer .banner{
      width: 100%;
      height: 4.06rem;
      border-radius: .2rem .2rem 0 0;
    }
    .cotainer .title{
      padding: .36rem .5rem .78rem;
      color: #000;
      font-size: .5rem;
    }
    .cotainer .status{
      display: inline-block;
      margin: 0 .5rem;
      padding: .12rem .5rem;
      color: #fff;
      font-size: .36rem;
      background: #4458ed;
	    border-radius: 0.1rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/benefits.vue